import { render } from '@wordpress/element';
import Events from './components/Events';

document.addEventListener('DOMContentLoaded', () => {
	const blockElement = document.querySelector('.fsdpe-calendar-wrapper');
	if (blockElement) {
		const showCalendar = blockElement.getAttribute('data-show-calendar') === 'true';
		const showCards = blockElement.getAttribute('data-show-cards') === 'true';
		const showList = blockElement.getAttribute('data-show-list') === 'true';
		const showSearch = blockElement.getAttribute('data-show-search') === 'true';
		const eventsPerPage = blockElement.getAttribute('data-events-per-page');

		// Get current date
		const now = new Date();
		const currentYear = now.getFullYear();
		const currentMonth = String(now.getMonth() + 1).padStart(2, '0'); // Month is zero-based, pad single digits
		const fetchEvents = async () => {
			try {
				const response = await fetch(`/wp-json/custom/v1/events?month=${currentMonth}&year=${currentYear}`);
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const eventsData = await response.json();

				render(
					<Events
						showCalendar={showCalendar}
						showCards={showCards}
						showList={showList}
						showSearch={showSearch}
						events={eventsData} // Pass the fetched data here
						eventsPerPage={eventsPerPage}
					/>,
					blockElement
				);
			} catch (error) {
				console.error('Error fetching events:', error);
			}
		};

		fetchEvents();
	}
});
